import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AddToCart,
  add_to_cart, del_from_cart,
  get_cart,
  UpdateCart,
  update_cart
} from "../../actions/orders";
import close from "../../assets/cancel.svg";
// import Tick from "../../assets/tick_outline.png";
// import Table from "../../common/Table";
import { amountFormat, getAccessLevel } from "../../config/helper";
import { season_icons } from "../ShopForTyres";
import { Table } from "antd";
//import OriginSummary from "../Cart/OriginSummary";
import OriginSummary from "./OriginSummary";
import check from "../../assets/check.svg";


export const Quantity = ({
  data,
  fromDetail,
  action,
  isEdit,
  isEditParent,
  setIsEdit
}) => {
  const [clicked, setClicked] = useState({});
  const [val, setVal] = useState(data.Quantity ? data.Quantity : "");
  const updateCart = useSelector((state) => state?.orders?.update_cart);
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const access = getAccessLevel("new_order");
  const isViewOnly = access === "view_only";
  const noAccess = access === "none";
  const newOrderAccess = getAccessLevel("new_order");
  const myOrderAccess = getAccessLevel("my_orders");
  const isViewOnlyNew = newOrderAccess === "view_only";
  const noAccessNew = newOrderAccess === "none";
  const isFullAccessMy = myOrderAccess === "full_access";
  const canEdit = (!isViewOnlyNew && !noAccessNew) || isFullAccessMy;

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (data?.Quantity) {
      setVal(data?.Quantity);
    }
    // eslint-disable-next-line
  }, [data]);
  useEffect(() => {
    if (!updateCart?.loading) {
      setClicked({});
    }
  }, [updateCart]);

  useEffect(() => {
    if (!isEdit) {
      setVal(data.Quantity);
    }
    // eslint-disable-next-line
  }, [isEdit]);
  return (
    <div className="quantity">
      {fromDetail ? (
        <>
          <div className="qty">
            <label>Qty</label>
            <input value={val} onChange={(e) => {
              if (Number.isNaN(Number(e.target.value?.trimStart()))) {
                return;
              }
              if (parseInt(e.target.value) || e.target.value === "")
                setVal(e.target.value ? parseInt(e.target.value) : e.target.value)
            }} />
          </div>
          {val &&
            localStorage.getItem("cartId") &&
            cart?.line_items?.find((ele) => ele.SKU === data.sku)?.Quantity ===
            val ? (
            <button
              className="bg-green primary-btn"
              onClick={() => {
                history.push("/cart");
              }}
            >
              Go To Cart
            </button>
          ) : (
            <button
              disabled={isViewOnly}
              className="primary-btn"
              onClick={() => {
                let obj = {
                  product_id: data.id,
                  quantity: val,
                };
                if (location?.state?.orderDetails) {
                  obj = { ...obj, ...location?.state?.orderDetails };
                }
                if (localStorage.getItem("cartId")) {
                  obj.cart_id = localStorage.getItem("cartId");
                }
                dispatch(add_to_cart(obj));
              }}
            >
              ADD TO ORDER
            </button>
          )}
        </>
      ) : isEdit ? (
        <>
          <input
            className="action-td"
            value={val}
            onChange={(e) => {
              if (Number.isNaN(Number(e.target.value?.trimStart()))) {
                return;
              }
              if (parseInt(e.target.value) || e.target.value === "")
                setVal(e.target.value ? parseInt(e.target.value) : e.target.value)
            }}
          />
          <span
            className="link"
            onClick={() => {
              if (!val) {
                return
              }
              if (action) {
                action(val);
                setIsEdit(false);
                return;
              }
              let obj = {
                email: localStorage.getItem("email"),
                product_id: data.id,
                quantity: val,
              };
              dispatch(update_cart(obj));
              setIsEdit(false);
              setClicked({ [data.id]: true });
            }}
          >
            Update
          </span>
          <img
            src={close}
            width={14}
            onClick={() => setIsEdit(false)}
            alt="edit"
          />
        </>
      ) : (
        <span
          className={`${updateCart?.loading && clicked[data.id] ? "loading" : ""
            }`}
        >
          <span>{data.Quantity}</span>
          {isEditParent ? (
            <span
              className="link"
              style={
                  !canEdit 
                  ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }
                  : {}
              }
              onClick={() => setIsEdit(true)}
            >
              Edit
            </span>
          ) : null}
        </span>
      )}
    </div>
  );
};

const Products = ({ step, isEdit: isEditParent, noMargin, originBlock, isStep1Valid,   selectedOrigins,setSelectedOrigins, isOriginStep1Valid, setOriginErrors, shippingAddresses, isChecked, setIsChecked }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const [isEdit, setIsEdit] = useState(false);
  const addToCart = useSelector((state) => state?.orders?.addToCart);
  const updateCart = useSelector((state) => state?.orders?.update_cart);
  const [tableScroll] = useState({ x: 1500 });
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const access = getAccessLevel("new_order");
  const isViewOnly = access === "view_only";
  const noAccess = access === "none";
  const disabled = isViewOnly || noAccess;
  const [poNumber, setPoNumber] = useState("");
  const [shipmentDate, setShipmentDate] = useState("");
  const originsCount = cart?.line_items?.length || 0;

  const showOriginCheckbox = cart?.line_items?.length > 1;
  const isCartEmpty =
  cart?.message === "Your cart is empty" ||
  !cart?.line_items ||
  cart?.line_items?.length === 0;

      useEffect(() => {
      if (cart?.line_items?.length === 1) {
        const onlyOriginId = cart.line_items[0].origin_id;
        setSelectedOrigins({ [onlyOriginId]: true });
      }
    }, [cart]);


  useEffect(() => {
    dispatch(
      get_cart({
        email: localStorage.getItem("email"),
      })
    );
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (addToCart.success) {
      let obj = {
        email: localStorage.getItem("email"),
      };
      toast.success("Product added to cart.");
      dispatch(get_cart(obj));
      dispatch({
        type: AddToCart.RESET,
      });
    }
    if (addToCart.success === false) {
      toast.error("Failed to add product in cart.");
      dispatch({
        type: AddToCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [addToCart]);

  useEffect(() => {
    if (updateCart.success) {
      let obj = {
        email: localStorage.getItem("email"),
      };
      toast.success("Quantity updated successfully.");
      dispatch(get_cart(obj));
      dispatch({
        type: UpdateCart.RESET,
      });
    }
    if (updateCart.success === false) {
      toast.success("Failed to update quantity.");
      dispatch({
        type: UpdateCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [updateCart]);

  const columns = [
    {
      title: "IP Code",
      dataIndex: "SKU",
      width: 8,
    },
    {
      title: "Origin",
      dataIndex: "oepregion",
      width: 11,
    },
    {
      title: "Rim",
      dataIndex: "rim",
      width: 4,
    },
    {
      title: "Size",
      dataIndex: "Size",
      width: 9,
    },
    {
      title: "LI",
      dataIndex: "li",
      width: 5,
    },
    {
      title: "SR",
      dataIndex: "sr",
      width: 5,
    },
    {
      title: "LR",
      dataIndex: "lr",
      width: 5,
    },
    {
      title: "Pattern",
      dataIndex: "Pattern",
      width: 9,
    },
    // {
    //   title: "Application",
    //   dataIndex: "appliction",
    //   width: 10,
    // },
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   width: 7,
    //   render: (_, row) => (
    //     <img
    //       src={season_icons[row?.category?.trim()?.toLowerCase()]}
    //       alt="season"
    //       className="season"
    //     />
    //   ),
    // },
    {
      title: "Unit Price",
      dataIndex: "Unit Price",
      width: 10,
      render: (_, row) => `$${parseFloat(row?.["Unit Price"]).toFixed(2)}`,
    },
    {
      title: "Quantity Ordered",
      dataIndex: "Quantity",
      width: 11,
      fixed: "right",
      render: (_, row) => <Quantity data={row} isEditParent={isEditParent} setIsEdit={(bool) => setIsEdit({ [row.id]: bool })} isEdit={isEdit[row.id]} />,
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      width: 11,
      fixed: "right",
      render: (_, row) => <p className="flex-between" style={{ color: "#262626" }}>
        <>{`$${amountFormat(row?.Amount)}`}</>
        <img
          className={`cancel ${disabled ? "disabled" : ""}`}
          src={close}
          alt={"close"}
          width={14}
          style={
            disabled
              ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" }
              : {}
          }
          onClick={() => {
            if (disabled) return; // safeguard
            dispatch(
              del_from_cart({
                id: row.id,
                email: localStorage.getItem("email"),
              })
            );
          }}
        />
      </p>,
    },
  ];
  return (
    <>
      <Table
         title={() => (
          <div className="origin-header-left">
            {step === 1 && originsCount > 1 && (
              <span
                className={
                  selectedOrigins[originBlock.origin_id] ? "check" : "uncheck"
                }
                onClick={() => {
                  const originId = originBlock.origin_id;

                  if (!isOriginStep1Valid(originId)) {
                    setOriginErrors((prev) => ({
                      ...prev,
                      [originId]: {
                        destination: !shippingAddresses?.[originId]
                          ? "Destination address is required"
                          : null,
                        shipmentDate: !shipmentDate?.[originId]
                          ? "Shipment date is required"
                          : null,
                      },
                    }));
                    return;
                  }

                  //clear errors & toggle
                  setOriginErrors((prev) => ({
                    ...prev,
                    [originId]: {},
                  }));

                  setSelectedOrigins((prev) => ({
                    ...prev,
                    [originId]: !prev[originId],
                  }));
                }}
              >
                {selectedOrigins[originBlock.origin_id] && (
                  <img src={check} alt="check" />
                )}
              </span>
                )}
          <span className="origin-title">
            {originBlock.origin_name}
            </span>
        </div>
      )}
          columns={columns}
          dataSource={originBlock.items}
          rowKey="id"
          pagination
          scroll={{ x: 1500 }}
        />
      <div className="total">
        <span className="note">
          Total Quantity: <strong> {originBlock.origin_total_quantity} pcs</strong>
        </span>
        <span className="note">
          Total Amount: <strong>$ {amountFormat(originBlock.origin_total_price)}</strong>
        </span>
      </div>

      {step === 1 &&(
        <OriginSummary
          step={step}
          origin={originBlock}
          poNumber={poNumber}
          shipmentDate={shipmentDate}
          selectedAddressId={
              shippingAddresses?.[originBlock.origin_id]
            }
            isChecked={isChecked}
            setIsChecked={setIsChecked}
        />
      )}
    </>
  );
};

export default Products;
